import { Typography } from '@mui/material'
import type { FC } from 'react'
import GridContainer from '../../../shared/components/GridContainer'
import CardProductDetailsBox from './CardProductDetailsBox'
import { cardProducts } from './cardProducts'

const CardProductSection: FC = () => (
  <div
    id="card-product-section"
    data-testid="card-product-section"
    className="flex flex-col py-16 md:pb-24 bg-ink-200"
    data-nosnippet
  >
    <GridContainer>
      <div className="flex flex-col gap-y-2 col-span-full md:pt-4 pb-6 md:pb-12 items-start md:items-center">
        <div>
          <Typography variant="h2">
            Credit cards built for <br className="hidden md:inline" />
            where you’re headed
          </Typography>
        </div>
      </div>
      <div className="grid gap-6 md:grid-cols-2 col-span-full">
        {cardProducts.map((creditCard) => (
          <div key={`credit-card-${creditCard.productName}`}>
            <CardProductDetailsBox {...creditCard} />
          </div>
        ))}
      </div>
    </GridContainer>
  </div>
)

export default CardProductSection
